import { render, staticRenderFns } from "./rpjh.vue?vue&type=template&id=47308011&scoped=true&"
import script from "./rpjh.vue?vue&type=script&lang=js&"
export * from "./rpjh.vue?vue&type=script&lang=js&"
import style0 from "./rpjh.vue?vue&type=style&index=0&id=47308011&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47308011",
  null
  
)

export default component.exports